import React from 'react';
import PropTypes from 'prop-types';

import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import CarouselComponent from '../../../../components/Carousel';
import { renderComponentTree } from '../../dynamicComponentTree';
import Slide from '../../../../components/Slide';
import RestaurantCardHome from '../RestaurantCardHome';
import ItemList from './ItemList';

// the following child components are supported:
const components = {
  RestaurantCardHome,
};

class Carousel extends React.Component {
  validateProps({ items }) {
    return Array.isArray(items);
  }

  componentDidMount() {
    const { items } = this.props;

    if (!this.validateProps({ items })) {
      throw new Error(`Incorrect prop-types for Storyblok Carousel component`);
    }
  }

  render() {
    const { items } = this.props;
    const firstItemKey = items[0].key;
    const restaurants = renderComponentTree(items, components);

    return (
      <Spacer spacing="medium 0">
        <ItemList {...this.props} />
        <CarouselComponent id={`carousel-${firstItemKey}`}>
          {restaurants.map((restaurant) => (
            <Slide key={`carousel-${firstItemKey}-${restaurant.key}`}>{restaurant}</Slide>
          ))}
        </CarouselComponent>
      </Spacer>
    );
  }
}

Carousel.propTypes = {
  landingPageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  cuisine: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      props: PropTypes.shape,
      key: PropTypes.string,
    }),
  ).isRequired,
};

export default Carousel;
